import { call, put, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { axiosRestInstance } from "../../../../common/axios";
import { PartnerEngagementCategoryListType } from "../../../slices/partner-program/engagement-configuration/Types";
import { partnerEngagementConfigurationSliceAction } from "../../../slices/partner-program/engagement-configuration";
import {
  partnerEngagementConfigurationSagaActionTypes,
  addEnagagementSagaAction,
  getPartnerEngagementConfigurationListSagaAction,
  getPartnerEngagementCategoryListSagaAction,
  updateEnagagementSagaAction,
  EngagementCategoryPayloadType,
} from "./saga-actions";
import { AddEngagementDetailsType } from "../regional-multipliers/saga-actions";

type getPartnerEngagementConfigurationDeatilsListAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};

type getPartnerEngagementCategoryDeatilsListAPIResponseType = {
  success: boolean;
  message: string;
  data: PartnerEngagementCategoryListType;
};

type addPartnerEngagementAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};

const getAllPartnersEngagementConfigurationListAPI = async () => {
  let response = axiosRestInstance
    .get<AxiosResponse<getPartnerEngagementConfigurationDeatilsListAPIResponseType>>(
      "/partner-program/engagements/getData"
    )
    .then((res) => res.data);
  return response;
};

const getAllPartnersEngagementCategoryConfigurationListAPI = async () => {
  let response = axiosRestInstance
    .get<AxiosResponse<getPartnerEngagementConfigurationDeatilsListAPIResponseType>>(
      "/partner-program/engagements/getCategories"
    )
    .then((res) => res.data);
  return response;
};

const getAllPartnersEngagementInsertConfigurationAPI = async (engagmentDetails: any) => {
  let response = axiosRestInstance
    .post<AxiosResponse<addPartnerEngagementAPIResponseType>>(
      "/partner-program/engagements/insert",
      engagmentDetails
    )
    .then((res) => res.data);
  return response;
};

const getAllPartnersEngagementUpdateConfigurationAPI = async (engagmentDetails: any) => {
  const id = engagmentDetails['ID'];
  delete engagmentDetails['ID'];
  let response = axiosRestInstance
    .put<AxiosResponse<addPartnerEngagementAPIResponseType>>(
      "/partner-program/engagements/update/" + id,
      engagmentDetails
    )
    .then((res) => res.data);
  return response;
};

const deleteEngagementAPI = async (engagementId: number) => {
  let response = axiosRestInstance
    .delete<AxiosResponse<addPartnerEngagementAPIResponseType>>
    ("/partner-program/engagements/" + engagementId)
    .then((res) => res.data);
  return response;
};

const insertCategoryEngagementApi = async (payload: {
  category_name: string;
  comments?: string;
}) => {
  let response = axiosRestInstance
    .post<AxiosResponse<addPartnerEngagementAPIResponseType>>(
      "/partner-program/engagements/insertCategory",
      payload
    )
    .then((res) => res.data);
  return response;
};

const updateCategoryEngagementApi = async (payload: EngagementCategoryPayloadType) => {
  const { ID, ...body } = payload;
  let response = axiosRestInstance
    .put<AxiosResponse<addPartnerEngagementAPIResponseType>>(
      `/partner-program/engagements/updateCategory/${ID}`,
      body
    )
    .then((res) => res.data);
  return response;
};

const deleteCategoryEngagementApi = async (categoryId: number) => {
  let response = axiosRestInstance
    .delete<AxiosResponse<addPartnerEngagementAPIResponseType>>(
      `/partner-program/engagements/deleteCategory/${categoryId}`
    )
    .then((res) => res.data);
  return response;
};

// ----------------------- API Above

function* getAllPartnerEngagementConfigurationListSaga(action: {
  type: string;
}) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementConfigurationLoading(true));
    let response: getPartnerEngagementConfigurationDeatilsListAPIResponseType = yield call(
      getAllPartnersEngagementConfigurationListAPI,
    );
    const list = response.data ? response.data.reverse() : [];
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementConfigurationList(list));
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementConfigurationLoading(false));
  } catch (e) {
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementConfigurationList([]));
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementConfigurationLoading(false));
    console.log(e);
  }
}


function* getAllPartnerEngagementCategoryListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementCategoryLoading(true));
    let response: getPartnerEngagementCategoryDeatilsListAPIResponseType = yield call(
      getAllPartnersEngagementCategoryConfigurationListAPI,
    );
    const list = response.data ? response.data.reverse() : [];
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementCategoryList(list));
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementCategoryLoading(false));
  } catch (e) {
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementCategoryList([]));
    yield put(partnerEngagementConfigurationSliceAction.setPartnerEngagementCategoryLoading(false));
    console.log(e);
  }
}


function* getAllPartnerEngagementInsertSaga(action: { type: string; payload: AddEngagementDetailsType }) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(true));
    let response: addPartnerEngagementAPIResponseType = yield call(
      getAllPartnersEngagementInsertConfigurationAPI,
      action.payload
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationMessage(response.message));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationStatus(true));

    if (response.success)
      yield put(getPartnerEngagementConfigurationListSagaAction());
  } catch (e: any) {
    yield put(
      partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationStatus(false));
    console.log(e);
  }
}


function* getAllPartnerEngagementUpdateSaga(action: { type: string; payload: AddEngagementDetailsType }) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(true));
    let response: addPartnerEngagementAPIResponseType = yield call(
      getAllPartnersEngagementUpdateConfigurationAPI,
      action.payload
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationMessage(response.message));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationStatus(true));
    if (response.success)
      yield put(getPartnerEngagementConfigurationListSagaAction());
  } catch (e: any) {
    yield put(
      partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationStatus(false));
    console.log(e);
  }
}


function* getAllPartnerEngagementCategoryInsertSaga(action: { type: string; payload: AddEngagementDetailsType }) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(true));
    let response: addPartnerEngagementAPIResponseType = yield call(
      insertCategoryEngagementApi,
      { category_name: String(action.payload.category_id ?? "") }
    );

    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationMessage(""));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationStatus(true));

    if (response.data.insertId) {
      action.payload.category_id = response.data.insertId;
      if (action.payload.ID) {
        yield put(updateEnagagementSagaAction(action.payload));
      } else {
        yield put(addEnagagementSagaAction(action.payload));
      }

    }
  } catch (e: any) {
    yield put(
      partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddpartnerEngagementConfigurationStatus(false));
    console.log(e);
  }
}

function* addStandaloneEngagementCategorySaga(action: {
  type: string;
  payload: EngagementCategoryPayloadType;
}) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setAddEngagementCategoryLoading(true));
    yield put(partnerEngagementConfigurationSliceAction.setAddEngagementCategoryMessage(""));
    const response: addPartnerEngagementAPIResponseType = yield call(
      insertCategoryEngagementApi,
      {
        category_name: action.payload.category_name,
      }
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddEngagementCategoryLoading(false));
    yield put(
      partnerEngagementConfigurationSliceAction.setAddEngagementCategoryMessage(
        response.message || "Engagement Category added successfully"
      )
    );
    yield put(
      partnerEngagementConfigurationSliceAction.setAddEngagementCategoryStatus(
        !!response.success
      )
    );
    if (response.success) {
      yield put(getPartnerEngagementCategoryListSagaAction());
    }
  } catch (e: any) {
    yield put(
      partnerEngagementConfigurationSliceAction.setAddEngagementCategoryMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerEngagementConfigurationSliceAction.setAddEngagementCategoryLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setAddEngagementCategoryStatus(false));
    console.log(e);
  }
}

function* updateEngagementCategorySaga(action: {
  type: string;
  payload: EngagementCategoryPayloadType;
}) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryLoading(true));
    yield put(partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryMessage(""));
    const response: addPartnerEngagementAPIResponseType = yield call(
      updateCategoryEngagementApi,
      action.payload
    );
    yield put(partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryLoading(false));
    yield put(
      partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryMessage(
        response.message || "Category updated successfully"
      )
    );
    yield put(
      partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryStatus(
        !!response.success
      )
    );
    if (response.success) {
      yield put(getPartnerEngagementCategoryListSagaAction());
    }
  } catch (e: any) {
    yield put(
      partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryLoading(false));
    yield put(partnerEngagementConfigurationSliceAction.setUpdateEngagementCategoryStatus(false));
    console.log(e);
  }
}

function* deleteEngagementCategorySaga(action: {
  type: string;
  payload: { ID: number };
}) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryLoading(true));
    yield put(partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryStatus("idle"));
    yield put(partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryMessage(""));
    const response: addPartnerEngagementAPIResponseType = yield call(
      deleteCategoryEngagementApi,
      action.payload.ID
    );
    if (response.success) {
      yield put(
        partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryStatus(
          "success"
        )
      );
      yield put(
        partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryMessage(
          response.message || "Engagement category deleted successfully"
        )
      );
      yield put(getPartnerEngagementCategoryListSagaAction());
    } else {
      yield put(
        partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryStatus(
          "error"
        )
      );
      yield put(
        partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryMessage(
          response.message || "Failed to delete engagement category"
        )
      );
    }
  } catch (e: any) {
    yield put(
      partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryStatus(
        "error"
      )
    );
    yield put(
      partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryMessage(
        e?.response?.data?.message || "Something went wrong"
      )
    );
    console.log(e);
  } finally {
    yield put(partnerEngagementConfigurationSliceAction.setDeleteEngagementCategoryLoading(false));
  }
}


function* deleteEngagementListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    yield put(partnerEngagementConfigurationSliceAction.setDeletePartnerEngagementConfigurationLoading(true));
    let response: getPartnerEngagementConfigurationDeatilsListAPIResponseType = yield call(
      deleteEngagementAPI,
      action.payload.ID
    );
    yield put(partnerEngagementConfigurationSliceAction.setDeletePartnerEngagementConfigurationStatus(true));
    yield put(partnerEngagementConfigurationSliceAction.setDeletePartnerEngagementConfigurationLoading(false));
    if (response.success)

      yield put(getPartnerEngagementConfigurationListSagaAction());
  } catch (e: any) {
    yield put(partnerEngagementConfigurationSliceAction.setDeletePartnerEngagementConfigurationStatus(false));
    yield put(
      partnerEngagementConfigurationSliceAction.setDeletePartnerEngagementConfigurationMessage(
        e?.response?.data?.message || "Something went wrong"
      )
    );
    console.log(e);
  } finally {
    yield put(partnerEngagementConfigurationSliceAction.setDeletePartnerEngagementConfigurationLoading(false));
  }
}

function* partnerEngagementConfigurationListSaga() {
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callPartnerEngagementConfigurationSaga, getAllPartnerEngagementConfigurationListSaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callAddPartnerEngagementCategorySaga, getAllPartnerEngagementCategoryListSaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callAddPartnerEngagementConfigurationSaga, getAllPartnerEngagementInsertSaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callDeletePartnerEngagementConfigurationSaga, deleteEngagementListSaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callInsertEngagementCategorySaga, getAllPartnerEngagementCategoryInsertSaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callUpdatePartnerEngagementConfigurationSaga, getAllPartnerEngagementUpdateSaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callAddStandaloneEngagementCategorySaga, addStandaloneEngagementCategorySaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callUpdateEngagementCategorySaga, updateEngagementCategorySaga);
  yield takeLatest(partnerEngagementConfigurationSagaActionTypes.callDeleteEngagementCategorySaga, deleteEngagementCategorySaga);
}

export default partnerEngagementConfigurationListSaga;
